export const colorToRgbaNotation = (color) => {
  if (typeof color === 'object' && color !== null) {
    return `rgba(${color.r}, ${color.g}, ${color.b}, ${color.a})`;
  }
  if (typeof color === 'string') {
    return color.trim();
  }
};
